// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3HaMM","search":"Settings_search__2Tugb","filter":"Settings_filter__eBlaD"};